import getVersion from '@altshuler-open/client-version-check';
import {
	API_GET_COUNTRIES,
	API_GET_CURRENCY,
	API_SET_CONTACT_LOGIN_TIME,
	API_GET_BANK_LIST,
	API_GET_CURRENCY_PAIRS,
	API_GET_FILE,
	API_GET_ALL_PLANS,
	API_GET_PLAN_CURRENCIES,
	API_GET_COUNTRIES_INCLUDE_FORBIDDEN,
	API_GET_PAYMENT_PURPOSE,
} from 'constants/db.constants';
import { createAsyncThunk } from '@reduxjs/toolkit';
import API from 'services/api.services';
import { setCurrencyPairs, setVersion } from 'state/reducers/global.reducers';
import { store } from 'state/store';
import { getOpenPendingRequestsByCompanyId } from './requests.services';
import { setUserNames } from 'state/reducers/user.reducers';

export const getCountriesAsync = createAsyncThunk('global/fetchCountriesAsync', (_, { rejectWithValue }) =>
	API.getInstance()
		.get(API_GET_COUNTRIES)
		.then((response) => response.data)
		.catch((err) => rejectWithValue(err))
);

export const getCountriesIncludeForbiddenAsync = createAsyncThunk(
	'global/fetchCountriesIncludeForbiddenAsync',
	(_, { rejectWithValue }) =>
		API.getInstance()
			.get(API_GET_COUNTRIES_INCLUDE_FORBIDDEN)
			.then((response) => response.data)
			.catch((err) => rejectWithValue(err))
);

export const getCurrencyAsync = createAsyncThunk('global/fetchCurrencyAsync', (_, { rejectWithValue }) =>
	API.getInstance()
		.get(API_GET_CURRENCY)
		.then((response) => {
			return response.data;
		})
		.catch((err) => rejectWithValue(err))
);

export const getPaymentPurpose = createAsyncThunk('global/fetchPaymentPurpose', (_, { rejectWithValue }) =>
	API.getInstance()
		.get(API_GET_PAYMENT_PURPOSE)
		.then((response) => {
			return response.data;
		})
		.catch((err) => rejectWithValue(err))
);

export const setContactLoginTime = createAsyncThunk('global/setContactLoginTime', (_, { dispatch, rejectWithValue }) =>
	API.getInstance()

		.post(API_SET_CONTACT_LOGIN_TIME)
		.then((response) => {
			const { firstName, firstNameHebrew } = response.data.contact;
			dispatch(setUserNames({ firstName, firstNameHebrew }));
			dispatch(getOpenPendingRequestsByCompanyId());
			return response.data;
		})
		.catch((err) => rejectWithValue(err))
);

export const getBankListAsync = createAsyncThunk('global/fetchBankListAsync', (_, { rejectWithValue }) =>
	API.getInstance()
		.get(API_GET_BANK_LIST)
		.then((response) => response.data)
		.catch((err) => rejectWithValue(err))
);

export function getCurrencyPairs() {
	return async (dispatch: any) => {
		await API.getInstance()
			.post(API_GET_PLAN_CURRENCIES, {
				companyId: store.getState().user.details?.companyId,
				planId: store.getState().user.details?.planId,
			})
			.then((response) => {
				dispatch(setCurrencyPairs(response?.data?.currenciesPairs));
			})
			.catch((error) => {});
	};
}

export function getFile(key: string, companyId: number) {
	return async (dispatch: any) => {
		const paramsSetting = {
			key,
			companyId,
		};
		const headers = {
			'Content-Type': 'application/octet-stream',
		};
		const additionalParameters = {
			responseType: 'blob',
		};

		await API.getInstance()
			.get(API_GET_FILE, paramsSetting, headers, additionalParameters)
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data], { type: response.headers['content-type'] })
				);
				window.open(url, '_blank');
			})
			.catch((error) => {
				console.log(error);
			});
	};
}

export const getPlansAsync = createAsyncThunk('global/fetchPlansAsync', (_, { rejectWithValue }) =>
	API.getInstance()
		.get(API_GET_ALL_PLANS)
		.then((response) => {
			return response.data.plans;
		})
		.catch((err) => rejectWithValue(err))
);

function writeAppVersionToDom(version: string) {
	const headerMetadataElement = document.querySelector("meta[name='appVersionNumber']");
	if (headerMetadataElement) {
		headerMetadataElement.setAttribute('content', version);
	}
}

export function setAppVersion() {
	return async (dispatch: any) => {
		await getVersion()
			.then((version: string) => {
				writeAppVersionToDom(version);
				dispatch(setVersion(version));
			})
			.catch((error: any) => {
				console.log("can't get version");
				console.log(error);
			});
	};
}
